export default __webpack_public_path__ + "static/media/Mark-4-HUD-02.5e6779ae.jpg";